// extracted by mini-css-extract-plugin
export default {"root":"DocumentDetailsHeader_root__-GQYq","inverted":"DocumentDetailsHeader_inverted__OZ5aW","col":"DocumentDetailsHeader_col__fxsST"};